import { createContext, useContext } from 'react'
import { useIntl } from 'react-intl'
import MessageBanner from 'LuxKit/Banners/MessageBanner'
import LineExclamationOctagonIcon from 'LuxKit/Icons/line/LineExclamationOctagonIcon'
import BodyText from 'LuxKit/Typography/BodyText'
import Group from 'components/utils/Group'
import styled from 'styled-components'
import { rem } from 'polished'
import { mediaQueryUp } from 'components/utils/breakpoint'

export const AccommodationRoomSelectionErrorContext = createContext(false)

const Banner = styled(MessageBanner)`
  .density-compact { padding-block: ${rem(8)}; }
`

const ErrorContainer = styled.div`
  grid-area: error;
  ${mediaQueryUp.tablet} { grid-area: auto; }
`

export default function AccommodationRoomSelectionError() {
  const error = useContext(AccommodationRoomSelectionErrorContext)
  const intl = useIntl()
  if (!error) return null
  return <ErrorContainer role="alert"><Banner kind="critical" density="compact" icon={false}>
    <Group direction="horizontal" verticalAlign="center" gap={8}>
      <LineExclamationOctagonIcon size="S" aria-hidden="true" />
      <BodyText variant="small">{intl.formatMessage({
        id: '-YdLpmzneBnLY_HIU11-',
        defaultMessage: 'Please select a room to continue.',
        description: 'Error shown in the accommodation booking summary after attempting to book or add to cart without selecting all requested rooms',
      })}
      </BodyText>
    </Group>
  </Banner>
  </ErrorContainer>
}
